import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { formatNisAmount } from '../../utils/labData';

/**
 * Footnote card for spend not tied to a Budget.
 */
const UnassignedSpendCard = ({ unassigned }) => {
  if (!unassigned || Number(unassigned.total_nis ?? 0) === 0) {
    return null;
  }

  return (
    <Card variant="outlined" sx={{ mt: 2, bgcolor: 'grey.50' }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Unassigned spend
        </Typography>
        <Typography variant="body1">
          {formatNisAmount(unassigned.total_nis)} across {unassigned.order_count ?? 0}{' '}
          orders ({unassigned.line_count ?? 0} lines) — credit-funded or legacy lines without a
          Budget.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default UnassignedSpendCard;
